// extracted by mini-css-extract-plugin
export default {"header":"BoardListViewHeader_header__e5-vO","headerCol":"BoardListViewHeader_headerCol__qNmfU","row":"BoardListViewHeader_row__z0XvC","col":"BoardListViewHeader_col__vESFR"};